export function dehydrate(reference) {
  return reference
}

export function hydrate({ base_source }) {
  return {
    base_source,
  }
}

export function bibliographyHydrate({ title, url, ref_type, pk }) {
  return {
    title,
    url,
    ref_type,
    pk,
  }
}
